export enum FileEventType {
    /**
     * 파일생성: FTS 에이전트가 생성에 관여한 파일.
     */
    CREATED,

    /**
     * 파일삭제
     */
    DELETED,

    /**
     * 파일발견: FTS 에이전트가 생성에 관여하지 않은 파일을 처음 봤을때 보내짐
     */
    DISCOVERY,

    /**
     * 파일접근: 관리대상 SW를 통해 열어서 FTS 에이전트가 복호화 시켜준 경우 (파일당 1회)
     */
    DECRYPTION,

    /**
     * 만료기한
     */
    EXPIRE,

    /**
     * 비인가 파일 접근
     */
    NOTAUTHROIZED,

    /**
     * 집중관리
     */
    FOCUSMATERIAL,

    /**
     * 파일변경
     */
    RESIZE,

    /**
     * 파일보관
     */
    VAULT,

    /**
     * 파일백업
     */
    BACKUP,

    /**
     * 파일반출 (내보내기)
     */
    EXPORT,

    /**
      * 반출파일 (내보내기)
      */
    EXPORT_ITEM,

    /**
      * 파일반입 (가져오기)
      */
    IMPORT,

    /**
      * 반입파일 (가져오기)
      */
    IMPORT_ITEM,

   	/**
     * 16: 파일공유
     */
    SHARE_FILE,

    /**
     * 17: 파일공유 가져오기
     */
    IMPORT_SHARED_FILE,

    /**
     * 18: 파일공유 수신열람
     */
    READ_MESSAGE,
	
    /**
     * 19: 미디어 내부로 컨테이너 반출
     */
    CREATED_IN_MEDIA,

    /**
      * 20: 미디어 내부에서 컨테이너 삭제
      */
    DELETED_IN_MEDIA
}

export const FileEventTypes = [
  {
    value: FileEventType[FileEventType.CREATED],
    label: '파일생성'
  },
  {
    value: FileEventType[FileEventType.DELETED],
    label: '파일삭제'
  },
  {
    value: FileEventType[FileEventType.DISCOVERY],
    label: '파일발견'
  },
  {
    value: FileEventType[FileEventType.DECRYPTION],
    label: '파일접근'
  },
  {
    value: FileEventType[FileEventType.EXPIRE],
    label: '만료기한'
  },
  {
    value: FileEventType[FileEventType.NOTAUTHROIZED],
    label: '비인가접근'
  },
  {
    value: FileEventType[FileEventType.FOCUSMATERIAL],
    label: '집중관리'
  },
  {
    value: FileEventType[FileEventType.RESIZE],
    label: '파일변경'
  },
  {
    value: FileEventType[FileEventType.VAULT],
    label: '파일보관'
  },
  {
    value: FileEventType[FileEventType.BACKUP],
    label: '파일백업'
  },
  {
    value: FileEventType[FileEventType.EXPORT],
    label: '반출'
  },
  {
    value: FileEventType[FileEventType.EXPORT_ITEM],
    label: '반출파일'
  },
  {
    value: FileEventType[FileEventType.IMPORT],
    label: '반입'
  },
  {
    value: FileEventType[FileEventType.SHARE_FILE],
    label: '문서공유'
  },
  {
    value: FileEventType[FileEventType.IMPORT_SHARED_FILE],
    label: '공유파일반입'
  },
  {
    value: FileEventType[FileEventType.READ_MESSAGE],
    label: '메시지열람'
  },
  {
    value: FileEventType[FileEventType.IMPORT_ITEM],
    label: '반입파일'
  },
  {
    value: FileEventType[FileEventType.CREATED_IN_MEDIA],
    label: '매채내 파일반출'
  },
  {
    value: FileEventType[FileEventType.DELETED_IN_MEDIA],
    label: '매채내 파일삭제'
  }
];
